<template>
  <div
    v-if="display"
    class="alert-notification dismissable animated bounceInRight"
    :class="alertClass"
    role="alert"
  >
    <span v-html="message"></span>
    <button
      type="button"
      aria-label="Close"
      v-if="dismissable"
      @click="alertClosed"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "Alert",
  computed: {
    display() {
      return this.$store.state.alert != null;
    },
    status() {
      return this.$store.state.alert.status || "";
    },
    message() {
      return this.$store.state.alert.message || "";
    },
    dismissable() {
      return this.$store.state.alert.dismissable || true;
    },
    alertClass() {
      if (this.status == "error") return "danger";
      return this.status;
    }
  },

  methods: {
    alertClosed() {
      this.$store.commit("showAlert", null);
    }
  }
};
</script>
